
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from "react-router-dom";
import App from './App';
import FAQManagementPage from './view/faq/FAQManagementPage'
import OrganizationSelectionModal from './view/org/OrganizationSelectionModal'
import SlipEditPopup from './view/hr/slip/SlipEditPopup'
// import SlipEditPanel from './view/hr/slip/SlipEditPanel'
import SlipDailyEmployeeTable from './view/hr/slip/SlipDailyEmployeeTable'
import SlipContractorTable from './view/hr/slip/SlipContractorTable'
import AutoPartViewer from './view/autoparts/AutoPartViewer'
import ReportContractorWage from './view/hr/report/ReportContractorWage'
import ReportFixingOrderPage from './view/report/ReportFixingOrderPage'
import ExcelEmployeeWage from './view/hr/report/ExcelEmployeeWage'
import ReportPendingWork from './view/report/ReportPendingWork'
import ReportInvoice from './view/report/ReportInvoice'
import ReportShopPurchaseOrder from './view/report/ReportShopPurchaseOrder'
import ReportEmployee from './view/hr/report/ReportEmployee'
import ReportEmployeeAbsence from './view/hr/report/ReportEmployeeAbsence'
import ReportAdvanceSalary from './view/hr/report/ReportAdvanceSalary'
import ReportSummary from './view/hr/report/ReportSummary'
import ReportCashFlowRecord from './view/report/ReportCashFlowRecord'
import ReportPickup from './view/report/ReportPickup'
// import ReportMechanicWork from './view/report/ReportMechanicWork'
import ReportEmployeeAdvanceSalaryRecord from './view/hr/report/ReportEmployeeAdvanceSalaryRecord'
// import WageDataGrid from './view/workdoc/WageDataGrid'
import SWTWorkDocDamage from './view/workdoc/SWTWorkDocDamage'
import RCKWorkDocDamage from './view/workdoc/RCKWorkDocDamage'
import SWTWorkDocDamageFasttrack from './view/workdoc/fast/SWTWorkDocDamage'
import WorkDocInvoiceMenu from './view/workdoc/WorkDocInvoiceMenu'
import SWTNewCustomerButton from './view/workdoc/SWTNewCustomerButton'
import SWTCustomerPage from './view/workdoc/SWTCustomerPage'
import SWTNewCarButton from './view/workdoc/SWTNewCarButton'
import SWTNewCarTypeButton from './view/workdoc/SWTNewCarTypeButton'
import ReportWork from './view/report/ReportWork'
import ReportRefixedWork from './view/report/ReportRefixedWork'
import ReportReceptionWork from './view/report/ReportReceptionWork'
import ReportReceptionPage from './view/report/ReportReceptionPage'
import ReportJobControlBoard from './view/report/ReportJobControlBoard'
import RecheckControlPage from './view/workdoc/recheckcontrol/RecheckControlPage'
import Plan from './view/workdoc/plan/Plan'
import MessageMenu from './view/menu/MessageMenu'
import LangMenu from 'view/menu/LangMenu'
import MessagePopup from './view/menu/MessagePopup'
import InvoiceStatusMenuButton from './view/menu/invoicestatus/InvoiceStatusMenuButton'
import PriceCompare from './view/workdoc/pricecompare/PriceCompare'
import ReportPurchaseOrderPage from './view/report/ReportPurchaseOrderPage'
import ReportQuotationPage from './view/report/ReportQuotationPage'
import ReportInvoicePage from './view/report/ReportInvoicePage'
import ReportReceiptPage from './view/report/ReportReceiptPage'
import ReportTaxinvoicePage from './view/report/ReportTaxinvoicePage'
import ReportCreditNotePage from './view/report/ReportCreditNotePage'
import ReportDebitNotePage from './view/report/ReportDebitNotePage'
import ReportBillingNotePage from './view/report/ReportBillingNotePage'
import ReportReceiptVoucherPage from './view/report/ReportReceiptVoucherPage'
import ReportPaymentVoucherPage from './view/report/ReportPaymentVoucherPage'
import ReportCashbillPage from './view/report/ReportCashbillPage'
import ReportPettyCashPage from './view/report/ReportPettyCashPage'
import ReportKKCProfit from './view/report/ReportKKCProfit'
import ReportKKCPurchaseOrderSummary from './view/report/ReportKKCPurchaseOrderSummary'
import PettyCashDoc from './view/cashflow/PettyCashDoc'
import WorkJobControlPage from './view/workdoc/jobcontrol/WorkJobControlPage'
import WorkJobOfficeControlPage from './view/workdoc/officecontrol/WorkJobOfficeControlPage'
import FixingOrderDoc from './view/workdoc/jobcontrol/FixingOrderDoc'
import WorkTimeRecord from './view/workdoc/jobcontrol/WorkTimeRecord'
import WorkDocGenForm from './view/workdoc/WorkDocGenForm'
import WorkDocStock from './view/workdoc/WorkDocStock'
import ReportContractor from './view/report/ReportContractor'
import InsurerPageModal from './view/insurer/InsurerPageModal'
import InsurerPage from './view/insurer/InsurerPage'
import SupplierPageModal from './view/po/SupplierPageModal'
import SupplierPage from './view/po/SupplierPage'
import ReportPage from './view/report/ReportPage'
import ReportCategoryPage from './view/report/ReportCategoryPage'
import TutorialPage from './view/tutorial/TutorialPage'
import WorkDocPurchaseOrder from './view/workdoc/WorkDocPurchaseOrder'
import WorkDocAttachmentDoc from './view/workdoc/WorkDocAttachmentDoc'
import WorkDocTimeline from './view/workdoc/WorkDocTimeline'
import WorkDocMessage from './view/workdoc/WorkDocMessage'
// import MyPlan from './view/workdoc/plan/MyPlan'
import StockManagementPage from './view/stock/StockManagementPage'
import StockSpecification from 'view/stock/StockSpecification'
import StockTyreManagementPage from './view/tyre/stock/StockTyreManagementPage'
import StockPainterBorrowingRecord from './view/stock/StockPainterBorrowingRecord'
import StockToolBorrowingRecord from './view/stock/StockToolBorrowingRecord'
import StockProductUsageRecord from './view/stock/StockProductUsageRecord'
import StockRequestReport from 'view/stock/StockRequestReport'
import CashFlowRecord from './view/cashflow/CashFlowRecord'
import IncentiveExpenseRecord from './view/cashflow/IncentiveExpenseRecord'
import IncentivePayeeButton from './view/cashflow/IncentivePayeeButton'
import PrintParkingCarDoc from './view/print/PrintParkingCarDoc'
import PrintReportKKCPurchaseOrderSummary from './view/print/PrintReportKKCPurchaseOrderSummary'
import PrintSSTWorkQCDoc from './view/print/sst/PrintSSTWorkQCDoc'
import SWTNewColorButton from './view/workdoc/SWTNewColorButton'
import SWTNewInsurerButton from './view/workdoc/SWTNewInsurerButton'
import EmployeeCodeButton from './view/hr/EmployeeCodeButton'
import Tracker from './view/workdoc/qrtracker/Tracker'
import WorkTracker from './view/workdoc/qrtracker/WorkTracker'
import MainDashboard from './view/dashboard/MainDashboard';
import QuotationFileTreePage from './view/qo/QuotationFileTreePage'
import SWTWorkUpload from './view/workdoc/SWTWorkUpload'
import CarDamageContainer from './view/workdoc/CarDamageContainer';
import RemarkRecordModal from './component/element/RemarkRecordModal';
import './index.css';
import 'icheck/skins/all.css'
import 'react-select/dist/react-select.css';
import 'bootstrap/dist/css/bootstrap.css';
import './asset/css/bf.css';
import AdminConfig from 'view/debug/AdminConfig'
//import 'bootstrap/dist/css/bootstrap-theme.css';
import TermOfServiceModal from './view/tos/TermOfServiceModal'
import NotificationScheduleConfig from './view/notification/NotificationScheduleConfig'
import Calendar from 'view/calendar/Calendar'
import WorkPostponeAppointmentButton from './view/workdoc/WorkPostponeAppointmentButton'
import ConfigOfficeWorkflow from './view/admin/ConfigOfficeWorkflow'
import ConfigMechanicWorkflow from './view/admin/ConfigMechanicWorkflow'
import DetectOffline from 'view/notification/DetectOffline'
import ReportTyreRepairPage from './view/tyre/ReportTyreRepairPage'
import ReportAllTyreRepairPage from './view/tyre/ReportAllTyreRepairPage'
import ReportTyreRetirePage from './view/tyre/ReportTyreRetirePage'
import ReportAllAssetPage from './view/asset/ReportAllAssetPage'
import ReportAssetVehiclePage from './view/tyre/report-asset-vehicle-page/ReportAssetVehiclePage'
import ReportAssetWork from 'view/report/ReportAssetWork'
import AssetVehicleDoc from 'view/tyre/report-asset-vehicle-page/AssetVehicleDoc'
import SWTCreditInstallment from './view/workdoc/SWTCreditInstallment'
import EmployeeWorkMonthlyReport from 'view/hr/EmployeeWorkMonthlyReport'
import reduxMiddleware from 'react-block-ui/reduxMiddleware';
import PermissionTable from 'view/permission/PermissionTable'
import ReportPartPriceComparePage from './view/report/ReportPartPriceComparePage'
import ReportPriceComparePage from './view/report/ReportPriceComparePage'
import ReportWithholdingTaxPage from './view/report/ReportWithholdingTaxPage'
import SubscribeStore from 'stores/SubscribeStore'
import CarPlan from './view/backupcar/CarPlan';
import ReportAppointmentReturn from 'view/backupcar/ReportAppointmentReturn'
import BackupCarRegistration from 'view/backupcar/BackupCarRegistration'
import BackupCarReservedButton from 'view/backupcar/BackupCarReservedButton'
import ReportAnalysisWorkCustomCost from 'view/report/analysis/ReportAnalysisWorkCustomCost'
// import loadable from '@loadable/component'
// const PermissionTable = loadable(() => import(/* webpackChunkName: "perm-table" */ 'view/permission/PermissionTable'), {
//     fallback: (<div>Loading...</div>),
//   })

const Provider = require('react-redux').Provider;
const createStore = require('redux').createStore;
const applyMiddleware = require('redux').applyMiddleware;
const content = require('./reducer');
const store = createStore(content, applyMiddleware(reduxMiddleware));


let nodes = [];

function renderReactDOM(component,element) {
    return ReactDOM.render(
      <Provider {... { store }}><App>{component}</App></Provider>,
      element
    );
}

function renderComponent(elementId, component,provider=false) {
  provider = true
  if (nodes.length > 0) {
    //nodes.forEach(node => { if(node.id==elementId) ReactDOM.unmountComponentAtNode(node.container)});
    nodes = nodes.reduce((rresult, node) => {
      if (node.id !== elementId) {
        rresult.push(node)
      } else {
        ReactDOM.unmountComponentAtNode(node.container)
      }
      return rresult
    }, []);
  }
  let container = document.getElementById(elementId);
  let instance = provider?renderReactDOM(
    component,
    container
  ):
  ReactDOM.render(
    component,
    container
  );
  nodes.push({ id: elementId, container: container });
  return instance;
}

export function registerRender(){

window.SubscribeStore = function(){
  return SubscribeStore;
}

window.renderReportAssetVehiclePage = function (elementId){
  return renderComponent(elementId,<HashRouter><ReportAssetVehiclePage/></HashRouter>,true)
}

window.renderReportAllAssetPage = function (elementId){
  return renderComponent(elementId,<HashRouter><ReportAllAssetPage/></HashRouter>,true)
}

window.renderReportTyreRepairPage = function (elementId){
  return renderComponent(elementId,<ReportTyreRepairPage/>)
}

window.renderReportAllTyreRepairPage = function(elementId){
  return renderComponent(elementId,<HashRouter><ReportAllTyreRepairPage/></HashRouter>)
}

window.renderReportTyreRetirePage = function (elementId){
  return renderComponent(elementId,<ReportTyreRetirePage/>)
}

window.renderDetectOffline = function (elementId) {
  return renderComponent(elementId, <DetectOffline />)
}

window.renderCalendar = function (elementId) {
  return renderComponent(elementId, <Calendar />)
}

window.renderOrganizationSelectionModal = function (elementId) {
  let childInst = null;
  renderComponent(elementId, <OrganizationSelectionModal onRef={(ref)=>{childInst = ref}} />)
  return childInst;
}
window.renderFAQManagementPage = function (elementId) {
  return renderComponent(elementId, <HashRouter><FAQManagementPage /></HashRouter>)
}

window.renderAutoPartViewer = function (elementId, carType, subCatId, callbackFunc) {
  return renderComponent(elementId, <AutoPartViewer carType={carType} subCatId={subCatId} onApplyItem={callbackFunc} />)
}

window.renderSlipEditPopup = function (elementId, slipId) {
  return renderComponent(elementId, <SlipEditPopup slipId={slipId} />)
}


window.renderSlipDailyWage = function (elementId) {
  return renderComponent(elementId, <SlipDailyEmployeeTable emType='daily' />)
}

window.renderSlipMonthlyWage = function (elementId) {
  return renderComponent(elementId, <SlipDailyEmployeeTable emType='monthly' />)
}

window.renderSlipContractor = function (elementId) {
  return renderComponent(elementId, <SlipContractorTable />)
}

window.renderReportEmployee = function (elementId) {
  return renderComponent(elementId, <ReportEmployee />)
}

window.renderReportEmployeeAbsence = function (elementId) {
  return renderComponent(elementId, <ReportEmployeeAbsence />)
}

window.renderReportAdvanceSalary = function (elementId) {
  return renderComponent(elementId, <ReportAdvanceSalary />)
}

window.renderReportHrSummary = function (elementId) {
  return renderComponent(elementId, <ReportSummary />)
}

window.renderReportEmployeeAdvanceSalaryRecord = function (elementId) {
  return renderComponent(elementId, <ReportEmployeeAdvanceSalaryRecord />)
}

window.renderReportContractorWage = function (elementId) {
  return renderComponent(elementId, <ReportContractorWage />)
}

window.renderReportFixingOrderPage = function (elementId) {
  return renderComponent(elementId, <ReportFixingOrderPage />)
}

window.renderSWTWorkDocDamage = function (elementId, workNo) {
  return renderComponent(elementId, <SWTWorkDocDamage workNo={workNo} />)
}

window.renderRCKWorkDocDamage = function (elementId, workNo) {
  return renderComponent(elementId, <HashRouter><RCKWorkDocDamage workNo={workNo} /></HashRouter>,true)
}

window.renderAdminConfig = function (elementId, workNo) {
  return renderComponent(elementId, <AdminConfig workNo={workNo} />)
}

window.renderPermissionTable = function (elementId) {
  return renderComponent(elementId, <PermissionTable  />)
}

window.SWTWorkDocDamageFasttrack = function (elementId, workNo) {
  return renderComponent(elementId, <HashRouter><SWTWorkDocDamageFasttrack workNo={workNo} /></HashRouter>)
}

window.renderWorkDocInvoiceMenu = function (elementId, workNo,onCreateInvoice,onMenuItemSelect=()=>{},onHistoryRowClick=()=>{}) {
  return renderComponent(elementId, <WorkDocInvoiceMenu workNo={workNo} onCreateInvoice={onCreateInvoice} 
    onMenuItemSelect={onMenuItemSelect} onHistoryRowClick={onHistoryRowClick}/>)
}

window.renderSWTNewCustomerButton = function (elementId) {
  return renderComponent(elementId, <SWTNewCustomerButton />)
}

window.renderSWTNewColorButton = function (elementId, onChange) {
  return renderComponent(elementId, <SWTNewColorButton onChange={onChange} />)
}

window.renderSWTNewCarTypeButton = function (elementId, onChange) {
  return renderComponent(elementId, <SWTNewCarTypeButton onChange={onChange} />)
}

window.renderEmployeeWorkMonthlyReport = function (elementId, em) {
  return renderComponent(elementId, <EmployeeWorkMonthlyReport em={em} />)
}

window.renderSWTCustomerPage = function (elementId, workNo) {
  return renderComponent(elementId, <SWTCustomerPage />)
}

window.renderSWTCreditInstallment = function (elementId,workNo,amount,onSave) {
  let childInst = null;
  renderComponent(elementId, <SWTCreditInstallment onRef={(ref)=>{childInst = ref}}   workNo={workNo} amount={amount} onSave={onSave}/>,true)
  return childInst;
}

window.renderSupplierPage = function (elementId) {
  return renderComponent(elementId, <SupplierPage />)
}

window.renderInsurerPage = function (elementId) {
  return renderComponent(elementId, <InsurerPage />)
}

window.renderWorkDocPriceCompare = function (elementId, workNo, saveCompleteFunc, closeFunc) {
  return renderComponent(elementId, <PriceCompare workNo={workNo} onSave={saveCompleteFunc} onClose={closeFunc} />)
}


window.renderWorkDocAttachmentDoc = function (elementId, workNo, onImageUpload) {
  return renderComponent(elementId, <WorkDocAttachmentDoc workNo={workNo} onImageUpload={onImageUpload} />)
}

window.renderSWTWorkUpload = function (elementId) {
  return renderComponent(elementId, <SWTWorkUpload  />)
}


window.renderWorkDocTimeline = function (elementId, workNo) {
  return renderComponent(elementId, <WorkDocTimeline workNo={workNo} />)
}

window.renderWorkDocMessage = function (elementId, workNo) {
  return renderComponent(elementId, <WorkDocMessage workNo={workNo} />)
}

window.renderWorkDocStock = function (elementId, workNo) {
  return renderComponent(elementId, <WorkDocStock workNo={workNo} />)
}


window.renderCarDamageContainer = function (elementId, workNo) {
  return renderComponent(elementId, <CarDamageContainer wo={workNo} />)
}

window.renderWorkPostponeAppointmentButton = function (elementId, workNo,saveCompleteFunc) {
  return renderComponent(elementId,<WorkPostponeAppointmentButton workNo={workNo} onSave={saveCompleteFunc}/>)
}

window.renderConfigOfficeWorkflow = function (elementId, workNo,saveCompleteFunc) {
  return renderComponent(elementId,<ConfigOfficeWorkflow workNo={workNo} onSave={saveCompleteFunc}/>)
}

window.renderConfigMechanicWorkflow = function (elementId, workNo,saveCompleteFunc) {
  return renderComponent(elementId,<ConfigMechanicWorkflow workNo={workNo} onSave={saveCompleteFunc}/>)
}

window.renderSWTNewCarButton = function (elementId, onChange, onClick) {
  return renderComponent(elementId, <SWTNewCarButton onChange={onChange} onClick={onClick} />)
}

window.renderSWTNewInsurerButton = function (elementId, onChange) {
  return renderComponent(elementId, <SWTNewInsurerButton onChange={onChange} />)
}

window.renderReportWork = function (elementId, showParkingTab,showPrintEmptyDoc) {
  let childInst = null;
  renderComponent(elementId, <ReportWork onRef={(ref)=>{childInst = ref}}   showParkingTab={showParkingTab} showPrintEmptyDoc={showPrintEmptyDoc}/>)
  return childInst;
}

window.renderReportAssetWork = function (elementId,showStatus) {
  let childInst = null;
  renderComponent(elementId, <HashRouter><ReportAssetWork onRef={(ref)=>{childInst = ref}}  showStatus={showStatus} /></HashRouter>,true)
  return childInst;
}

window.renderReportRefixedWork = function (elementId, showParkingTab,showPrintEmptyDoc) {
  return renderComponent(elementId, <ReportRefixedWork showParkingTab={showParkingTab} showPrintEmptyDoc={showPrintEmptyDoc}/>)
}

window.renderReportReceptionWork = function (elementId, config={},onRowWorkClick) {
  let childInst = null;
  config = Object.assign({showParkingTab:false,showPrintEmptyDoc:false},config)
  renderComponent(elementId, <ReportReceptionWork onRef={(ref)=>{childInst = ref}}  {...config} onRowWorkClick={onRowWorkClick}/>)
  return childInst;
}

window.renderReportReceptionPage = function (elementId,props={}){
  return renderComponent(elementId,<HashRouter><ReportReceptionPage {...props}/></HashRouter>);
}

window.renderAssetVehicleDoc  = function(elementId,vehicleId){
  return renderComponent(elementId,<HashRouter><AssetVehicleDoc  vehicleId={vehicleId}  showInfoOnly={true} readOnly={true}/></HashRouter>)
}

window.renderReportPlan = function (elementId) {
  return renderComponent(elementId, <Plan />)
}

window.renderReportPendingWork = function (elementId) {
  return renderComponent(elementId, <ReportPendingWork />)
}

window.renderReportInvoice = function (elementId) {
  return renderComponent(elementId, <ReportInvoice />)
}

window.renderReportShopPurchaseOrder = function (elementId) {
  return renderComponent(elementId, <ReportShopPurchaseOrder />)
}


window.renderReportWorkJobControlPage = function (elementId,props={control:'workJob'}) {
  return renderComponent(elementId, <WorkJobControlPage {...props}/>)
}

window.renderReportWorkJobOfficeControlPage = function (elementId) {
  return renderComponent(elementId, <WorkJobOfficeControlPage />)
}

window.renderReportRecheckControlPage = function (elementId) {
  return renderComponent(elementId,<RecheckControlPage/>)
}


window.renderReportPurchaseOrderPage = function (elementId, config) {
  config = Object.assign({onTableShow:()=>{},onDocShow:()=>{},initPoNo:''},config);
  return renderComponent(elementId, <ReportPurchaseOrderPage {...config} />)
}

window.renderReportPriceComparePage = function (elementId) {
  return renderComponent(elementId,<HashRouter><ReportPriceComparePage /></HashRouter>);
}

window.renderReportPartPriceComparePage = function (elementId) {
  return renderComponent(elementId,<HashRouter><ReportPartPriceComparePage /></HashRouter>);
}

window.renderReportContractor = function (elementId) {
  return renderComponent(elementId, <ReportContractor />)
}

window.renderWorkDocPurchaseOrder = function (elementId, workNo,props={}) {
  return renderComponent(elementId, <WorkDocPurchaseOrder workNo={workNo} {...props}/>)
}

window.renderReportPage = function (elementId) {
  return renderComponent(elementId, <ReportPage />)
}

window.renderReportCategoryPage = function (elementId,props={}) {
  props = Object.assign({showAdminMenu:false},props)
  return renderComponent(elementId, <ReportCategoryPage {...props}/>,true)
}



window.renderStockManagementPage = function (elementId,config) {
  config = Object.assign({showOrder:true,showPickup:true,showLocation:true,showReplacement:true,showProductOption:false,showDeleteMenu:false},config)
  return renderComponent(elementId, <HashRouter><StockManagementPage config={config}/></HashRouter>,true)
}

window.renderStockSpecification = function (elementId,config) {
  config = Object.assign({showOrder:true,showPickup:true,showLocation:true,showReplacement:true,showProductOption:false},config)
  return renderComponent(elementId, <HashRouter><StockSpecification config={config}/></HashRouter>,true)
}

window.renderStockTyreManagementPage =  function (elementId,showCostPerUnitField,showStoreOutTab,showCheckReportTab) {
  let childInstance = null;  
  let config = {showCostPerUnitField:showCostPerUnitField,showStoreOutTab:showStoreOutTab,showCheckReportTab:showCheckReportTab}  
  renderComponent(elementId, <StockTyreManagementPage onRef={(ref)=>{childInstance = ref}}  config={config}/>,true)

  return childInstance
}


window.renderStockPainterBorrowingRecord = function (elementId) {
  return renderComponent(elementId, <StockPainterBorrowingRecord />)
}

window.renderStockToolBorrowingRecord = function (elementId) {
  return renderComponent(elementId, <StockToolBorrowingRecord />)
}

window.renderStockProductUsageRecord = function (elementId) {
  return renderComponent(elementId, <StockProductUsageRecord />)
}

window.renderStockRequestReport = function (elementId,props={}){
  return renderComponent(elementId,<StockRequestReport {...props}/>)
}

window.renderQuotationPage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportQuotationPage onDocShow={show_doc_callback} />)
}

window.renderInvoicePage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportInvoicePage onDocShow={show_doc_callback} />)
}

window.renderReceiptPage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportReceiptPage onDocShow={show_doc_callback} />)
}

window.renderTaxinvoicePage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportTaxinvoicePage onDocShow={show_doc_callback} />,true)
}

window.renderCreditNotePage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportCreditNotePage onDocShow={show_doc_callback} />)
}

window.renderDebitNotePage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportDebitNotePage onDocShow={show_doc_callback} />)
}

window.renderBillingNotePage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportBillingNotePage onDocShow={show_doc_callback} />)
}

window.renderReceiptVoucherPage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportReceiptVoucherPage onDocShow={show_doc_callback} />)
}

window.renderPaymentVoucherPage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportPaymentVoucherPage onDocShow={show_doc_callback} />)
}

window.renderCashbillPage = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportCashbillPage onDocShow={show_doc_callback} />)
}

window.renderPettyCashPage = function (elementId){
  return renderComponent(elementId,<ReportPettyCashPage />)
}

window.renderReportWithholdingTaxPage = function (elementId){
  return renderComponent(elementId,<ReportWithholdingTaxPage />)
}

window.renderReportKKCProfit = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportKKCProfit />)
}

window.renderReportKKCPurchaseOrderSummary = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <ReportKKCPurchaseOrderSummary />)
}

window.renderPrintReportKKCPurchaseOrderSummary = function (elementId, show_doc_callback) {
  return renderComponent(elementId, <PrintReportKKCPurchaseOrderSummary />)
}

window.renderPrintParkingCarDoc = function (elementId, title) {
  return renderComponent(elementId, <PrintParkingCarDoc title={title} />)
}

window.renderEmployeeCodeButton = function (elementId,type, title, value,label,subLabel) {
  return renderComponent(elementId, <EmployeeCodeButton type={type} title={title} value={value} label={label} subLabel={subLabel}/>)
}

window.renderTutorialPage = function (elementId) {
  return renderComponent(elementId, <TutorialPage />)
}

window.renderMainDashboard =  function (elementId) {
  return renderComponent(elementId, <MainDashboard/>)
}


window.renderQuotationFileTreePage =  function (elementId) {
  return renderComponent(elementId, <QuotationFileTreePage/>)
}



window.renderCashFlowRecordPage =  function (elementId) {
  return renderComponent(elementId, <CashFlowRecord/>)
}

window.renderReportCashFlowRecord = function (elementId){
  return renderComponent(elementId,<ReportCashFlowRecord/>)
}


window.renderIncentiveExpenseRecordPage =  function (elementId) {
  return renderComponent(elementId, <IncentiveExpenseRecord/>)
}

window.renderIncentivePayeeButton = function(elementId,onSelectItemFunc){
  return renderComponent(elementId,<IncentivePayeeButton onSelectItem={onSelectItemFunc}/>)
}


window.renderInvoiceStatusMenuButton =  function (elementId,config,onChange) {
  const {ivNo,docNo,amount,docType,hasVat} = config
  return renderComponent(elementId, <InvoiceStatusMenuButton {...config} onChange={onChange}/>)
}

window.renderMessageMenu = function(elementId){
  return renderComponent(elementId, <MessageMenu />)
}

window.renderLangMenu = function (elementId) {
  return renderComponent(elementId, <LangMenu />)
}

window.renderNotificationScheduleConfig = function(elementId,workNo,mobileNo,alertType,onSave){
  let childInst = null;
  renderComponent(elementId, <NotificationScheduleConfig onRef={(ref)=>{childInst = ref}} alertType={alertType}  workNo={workNo} mobileNo={mobileNo} onSave={onSave}/>)
  return childInst;  
}

window.renderRemarkRecordModal = function(elementId,props){
  
  return renderComponent(elementId, <RemarkRecordModal {...props}/>)
    
}

window.renderCarPlan = function(elementId,props={}){
  return renderComponent(elementId, <CarPlan {...props}/>)    
}

window.renderReportAppointmentReturn = function(elementId,props={}){
  return renderComponent(elementId,<ReportAppointmentReturn {...props} />)
}

window.renderBackupCarRegistration = function(elementId,props={}){
  return renderComponent(elementId,<BackupCarRegistration {...props} />)
}

window.renderBackupCarReservedButton = function(elementId,props={}){
  return renderComponent(elementId,<BackupCarReservedButton {...props} />)
}

window.renderReportAnalysisWorkCustomCost = function(elementId,props={}){
  props = Object.assign({renderMenu:()=>{return (<div/>)}},props);
  return renderComponent(elementId,<ReportAnalysisWorkCustomCost  {...props} />)
}


window.removeReactNode = function (elementId) {
  if (nodes.length > 0) {
    //nodes.forEach(node => { if(node.id==elementId) ReactDOM.unmountComponentAtNode(node.container)});
    nodes.map((node, index) => {
      if (node.id === elementId) {
        ReactDOM.unmountComponentAtNode(node.container)
      }
      return node
    });
  }
}

}



// WEBPACK FOOTER //
// ./src/window-render.js